export default {
  backToProjects: "Back",
}